import axios from "@/axios.js"

export default {
  getAllModules({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/module", data)
        .then((response) => {
          commit('SET_MODULES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAModule({ commit }, moduleId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/module/"+moduleId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createModule({ commit }, moduleData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/module/create", moduleData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateModule({ commit }, moduleData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/module/"+moduleData.id, moduleData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getAllTags({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/tag/viewTag")
        .then((response) => {
          commit('SET_TAGS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
